<div class=" banner_header">
    <div class="col-md-12">
        <h2>Mobile App</h2>
    </div>
</div>

  <!--Content Start-->
  <section class="section_box_one"> 
    <div class="container">
      <h2>Attendance App Process Flow</h2>

      <div class="row inner_pad">
        <div class="col-md-6"> 
          <h3>Adding Invigilators</h3>
          <p>
            Invigilators are added by the State CoE and mapped to the Exam centre in the AITT Portal using their Login
          </p>
        </div>
        <div class="col-md-6 "> 
          <h3>Login</h3>
          <p>
            Invigilators will have to download the AITT App available in play store and login with the registered credentials
          </p>
        </div>
        
      </div>

      <div class="row inner_pad">
        <div class="col-md-6 "> 
          <h3>Validation</h3>
          <p>
            Invigilator login validated with OTP sent to their registered mobile. Profile of the invigilator is captured in the database (His photo and other details)
          </p>
        </div>

        <div class="col-md-6"> 
          <h3>Attendance Marking</h3>
          <p>
            When a candidate logs in a QR code appears in the screen. Invigilator will scan the QR code to mark attendance. 
          </p>
        </div>
        
      </div>


      <div class="row inner_pad">
        <div class="col-md-6"> 
          <h3>Candidate Photo & lat. Long coordinates </h3>
          <p>
            While marking attendance the invigilator captures the photo of the candidate which captures the latitude and Longitude of the location
          </p>
        </div>
        <div class="col-md-6"> 
          <h3>Marking Absentees</h3>
          <p>
            Absentees are marked separately using the APP
          </p>
        </div>
      </div>


      <div class="row inner_pad">
        <div class="col-md-12">
          <img src="assets/images/att.png" width="100%"/>
        </div>
        
      </div>

      <div class="row inner_pad">
        <div class="col-md-12">
          <div class="downlaod_cls">
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.nimi.aitt2020attendance"> <i class="fa fa-download" aria-hidden="true"></i>
               App Download Link</a>
          </div>
        </div>
        <div class="col-md-12">
          <div class="cls_cntr">
            How to use this mobile application? <a target="_blank" href="assets/pdf/AITT - CBT Candidate Attendance Mobile Application User Manual.pdf">Click Here </a>
          </div>
        </div>
      </div>

    </div>
  </section>  
  <!--Content End-->




<style>
  
    .banner_header{
        background: #2955a9;
    padding: 10px 0px;
    text-align: left;
    color: #fff;
    margin: 0px;
    }
    .banner_header h2{
        font-size: 21px;
    }
    .download_section{        
        padding: 40px 0px;
        text-align: center;
    }
    .dwn_btm{
        padding-bottom: 60px;
    }
    .steps{
        left: 0px;
    height: 40px;
    width: 40px;
    background-color: #29ab55;
    border-radius: 50%;
    display: inline-block;
    font-size: 24px;
    text-align: center;
    color: #fff;
    position: absolute;
    }
    .step_cls{
        padding: 0px 70px 30px;
    }
    .click_here{
        background: #2955a9;
    padding: 5px 15px;
    color: #fff;
    font-size: 10px;
    font-weight: 500;
    border-radius: 10px;
    width: fit-content;
    cursor: pointer;
    }
    .click_here:hover{
        background-color: #000;
        text-decoration: none;
    }
    .section_box_one{
        padding: 30px 0px;
      }
      .section_box_one h2{
        border-bottom: 5px solid #000;
      padding-bottom: 5px;
      width: fit-content;
      margin: 0 auto 30px;
      }
   .inner_pad{
     padding-bottom: 20px;
   }

   .downlaod_cls{
    text-align: center;
  }
  .downlaod_cls a{
    background: #2955a9;
    padding: 10px 30px;
    border-radius: 10px;
    color: #fff;
    font-weight: bold;
  }
  .downlaod_cls:hover a{
    text-decoration: none;
    background-color: #29ab55;
  }
  @media only screen and (max-width: 767px)  {      
       h2{
      font-size: 24px;
      text-align: center;
    }
    .steps{
        left: 20px
    }
    .click_here{
        display: block;
    }
    .step_cls {
        padding: 0px 70px 30px;
    }

    }
</style>





